<template>
  <div class="appointment-page">
    <v-container id="appointment-confirm" data-id="appointment-confirm" v-if="hasLoaded">
      <fo-header :content="headerData" :config="clientPage?.config.header" :availableLanguages="availableLanguages"
        dataId="appointment-confirm-header" @changeLanguage="getClientPage($event)" />

      <v-row no-gutters class="mt-4 container px-8 mx-8">
        <v-col :cols="$vuetify.breakpoint.smAndUp ? 6 : 12" :offset="$vuetify.breakpoint.smAndUp ? 3 : 0">
          <appointmentTitle :title="$t('appointment.confirmationPage.title', { retailerName: retailerName })"
            :subtitle="$t('appointment.confirmationPage.subtitle')" subtitleFormat="" />
        </v-col>
        <v-row no-gutters class="container mt-4  d-flex align-center justify-center"
          :class="$vuetify.breakpoint.smAndUp ? 'px-8 mx-8' : ''" v-if="confirmedSlot">
          <v-col sm="12" md="4" offset-sm="0" offset-md="2">
            <appointmentCard :carrier="carrierInfo" :showAction="canUpdate" :language="language"
              :selectedSlot="confirmedSlot" @action="handleModifyAppointment"
              :selectedSlotTitle="$t('appointment.confirmationPage.selectedSlotTitle')"
              :actionText="$t('appointment.confirmationPage.actionText')" />
          </v-col>
          <v-col sm="12" md="4" class="mr-auto">
            <v-row no-gutters :class="$vuetify.breakpoint.smAndUp ? 'ml-8' : 'ml-0'" class="appointment-confirmed">
              <v-col cols="12">
                <span :class="$vuetify.breakpoint.smAndUp ? 'h1' : 'h2'">
                  {{ $t('appointment.confirmationPage.appointmentConfirmed') }}
                </span>
              </v-col>
              <v-col cols="12" class="mt-1">
                <span :class="$vuetify.breakpoint.smAndUp ? 'regular14' : 'regular12'">
                  {{ $t('appointment.confirmationPage.appointmentConfirmedSubtitle') }}
                </span>
              </v-col>
              <v-col cols="12" class="d-flex justify-left mt-6">
                <mp-button :text="$t('appointment.confirmationPage.close')" format="black" @click="handleClose()"
                  dataId="appointment-close" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-4 container px-8 mx-8" v-else>
          <v-col cols="6" offset="3">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-col>
        </v-row>
      </v-row>

      <portal to="footer">
        <fo-footer :config="clientPage?.config.footer" dataId="appointment-confirm-footer" />
      </portal>
    </v-container>
  </div>
</template>

<script>
import foFooter from '@/components/footer/footer.vue'
import foHeader from '@/components/header/header.vue'
import { ROUTES, DeliveryClientPageType } from '@/constants'
import { clientPageMixin } from '@/mixins'
import mixins from 'vue-typed-mixins'
import appointmentCard from './appointmentCard.vue'
import appointmentConfirm from './appointmentConfirmPage.vue'
import appointmentTitle from './appointmentTitle.vue'

export default mixins(clientPageMixin).extend({
  name: 'mp-appointment-confirm',
  components: {
    foFooter,
    foHeader,
    appointmentTitle,
    appointmentCard,
    appointmentConfirm,
  },
  data() {
    return {
      hasLoaded: false,
      confirmedSlot: null,
      showModifyButton: true,
      canUpdate: false,
      isConfirmationPage: true,
      retailerName: null,
    }
  },
  async beforeMount() {
    try {
      const {
        query: { language },
      } = this.$route

      const languageToUse = language?.toString()
      await this.getClientPage(languageToUse)

      if (!this.clientPage || !this.delivery) {
        return this.$router.push({ name: ROUTES.NOT_FOUND })
      }
      this.confirmedSlot = this.getConfirmedSlot()
      this.canUpdate = this.delivery.canUpdate || false
      this.retailerName = this.delivery?.retailer?.name || ''

      this.hasLoaded = true
    } catch (error) {
      this.$router.push({ name: ROUTES.NOT_FOUND })
    }
  },
  methods: {
    getConfirmedSlot() {
      if (this.delivery && this.delivery.deliverySlot && this.delivery.deliverySlot.start && this.delivery.deliverySlot.end) {
        return this.delivery.deliverySlot
      }
      return null
    },


    handleModifyAppointment() {
      if (!this.canUpdate) return
      //  case user can update the slot, we need to redirect to the appointment page
      const { accessToken } = this.$route.params
      this.$router.push({ name: DeliveryClientPageType.APPOINTMENT, params: { accessToken }, query: { language: this.language } })
    },

    handleClose() {
      window.close()
      if (!window.opener) {
        // add message to the user that the window has been closed
        this.$store.dispatch('setSnackbar', {
          message: this.$t('messages.appointment.closeWindowFailed'),
          type: MESSAGE_TYPES.WARNING,
          timeout: MESSAGE_TIMEOUTS.DEFAULT,
        })
        this.$router.push({ name: ROUTES.HOME })
      }
    }
  },
  computed: {
    carrierInfo() {
      return {
        logo: this.delivery.carrier.logo,
        name: this.delivery.carrier.name,
      }
    },
    language() {
      const {
        query: { language },
      } = this.$route
      const urlLanguage = language?.toString()
      const pageLanguage = this.clientPage?.language
      return urlLanguage || pageLanguage || DEFAULT_LANGUAGE
    },
  },
})
</script>

<style lang="scss" scoped>
.appointment-page {
  background-color: $main-lighten-80-color;
  min-height: 100vh;
}

.appointment-confirmed {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3.2rem;
}
</style>